export default __webpack_public_path__ + "static/media/rabbit.e14e280d.png";